// console.log('ENV: ', process.env);

import Vue from 'vue'
import router from './router' // 路由配置
import './utils/permission' // 权限控制
import store from './store' // 状态管理器
import App from './App.vue'

// 使用Element-UI
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

Vue.use(ElementUI)

Vue.config.productionTip = false // 阻止启动生产消息
Vue.config.ignoredElements = ['wx-open-launch-app', 'wx-open-launch-weapp'] // 忽略微信小程序元素

window.Vue = new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')